import React, { createContext, useContext, useState, ReactNode } from 'react'

type BundleNotificationsDrawerContextType = {
  isOpened: boolean
  openDrawer: () => void
  closeDrawer: () => void
  onOpenHandler: () => void
  bundleData?: {
    items: Array<{
      id: number
      name: string
      image?: string
      price?: string
    }>
    description?: string
  }
  setBundleData: (data?: {
    items: Array<{
      id: number
      name: string
      image?: string
      price?: string
    }>
    description?: string
  }) => void
}

const BundleNotificationsDrawerContext = createContext<
  BundleNotificationsDrawerContextType | undefined
>(undefined)

export const BundleNotificationsDrawerProvider: React.FC<{
  children: ReactNode
}> = ({ children }) => {
  const [isOpened, setIsOpened] = useState(false)
  const [bundleData, setBundleData] = useState<
    | {
        items: Array<{
          id: number
          name: string
          image?: string
          price?: string
        }>
        description?: string
      }
    | undefined
  >(undefined)

  const openDrawer = () => {
    setIsOpened(true)
  }

  const closeDrawer = () => {
    setIsOpened(false)
  }

  const onOpenHandler = () => {
    // do nothing, handler is required by drawer
  }

  return (
    <BundleNotificationsDrawerContext.Provider
      value={{
        isOpened,
        openDrawer,
        closeDrawer,
        onOpenHandler,
        bundleData,
        setBundleData,
      }}
    >
      {children}
    </BundleNotificationsDrawerContext.Provider>
  )
}

export const useBundleNotificationsDrawerContext = () => {
  const context = useContext(BundleNotificationsDrawerContext)
  if (context === undefined) {
    throw new Error(
      'useBundleNotificationsDrawerContext must be used within a BundleNotificationsDrawerProvider'
    )
  }
  return context
}

